module.exports = __webpack_public_path__ + "img/hexa.ec881c02.svg";